import { apolloClient } from "../../../vue-apollo";
import {
  LIST_MODULOS_EMPRESAS,
  BUSCAR_MENU,
  GET_INTERFAZ,
  GET_URLS_INTERNAS
} from "@/apollo/queries";
import {
  EDIT_MODULOS,
  EDIT_INTERFAZ,
  ACTUALIZAR_MENU
} from "@/apollo/mutations";

import {
  exQue
} from "@/utils/gql.js";

export default {
  namespaced: true,
  state: {
    listaModulosActivos: [],
    listaModulosDesactivados: [],
    menu: [],
    selectedMenuGeneral: { id_header: null, nombre_header: '', color_activo: '' },
    general: null,
    urlsInternas: []
  },

  mutations: {
    setUrlsInternas(state, urlsInternas) {
      state.urlsInternas = urlsInternas || [];
    },

    setListaModulos(state, modulos) {
      let generalIndex = modulos.findIndex(mod => mod.privilegio_modulos.id_modulo === 29);
      if (generalIndex > -1) {
        //guardar general
        state.general = {...modulos[generalIndex]};
        
        
        //eliminar general
        modulos.splice(generalIndex, 1);
      }
      
      state.listaModulosActivos = modulos.filter(mod => mod.id_estado_fk === 1);
      let activosIds = state.listaModulosActivos.reduce((acc, mod) => {
        acc[mod.id_detalle] = true;
        return acc;
      }, {});

      state.listaModulosDesactivados = modulos.filter(mod => activosIds[mod.id_detalle] === undefined);
    },

    editListaModulos(state, modulos) {
      modulos
      // state.listaModulosActivos = modulos.filter(mod => mod.id_estado_fk === "1");
      // state.listaModulosDesactivados = modulos.filter(mod => mod.id_estado_fk !== "1");
    },

    setMenu(state, menu) {
      state.menu = menu;
    },

    setSelectedMenuGeneral(state, menuGeneral) {
      state.selectedMenuGeneral = menuGeneral
    },
    cleanSelectedMenuGeneral(state) {
      state.selectedMenuGeneral = { id_header: null, nombre_header: '', color_activo: '' };
    }
  },

  actions: {
    async getListaModulos({ commit }) {
      const params = {
        query: LIST_MODULOS_EMPRESAS
      }

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.listModulosEmpresas;
        commit("setListaModulos", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getMenu({ commit }) {
      const params = {
        query: BUSCAR_MENU
      }

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.buscarMenu;
        commit("setMenu", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getInterfaz() {
      const params = {
        query: GET_INTERFAZ
      }

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.getInterfaz;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async editInterfaz(_, payload) {
      const params = {
        mutation: EDIT_INTERFAZ,
        variables: payload
      }

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.editInterfaz;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async actualizarMenu(_, payload) {
      const params = {
        mutation: ACTUALIZAR_MENU,
        variables: payload
      }

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.actualizarMenu;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async editModulos({ commit }, payload) {
      const params = {
        mutation: EDIT_MODULOS,
        variables: payload
      }

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.editModulosEmpresas;
        commit("editListaModulos");
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    setSelectedMenuGeneral({ commit }, menuGeneral) {
      commit("setSelectedMenuGeneral", menuGeneral);
    },
    cleanSelectedMenuGeneral({ commit }) {
      commit("cleanSelectedMenuGeneral");
    },
    async getUrlsInternas({ commit }) {
      let response = await exQue(GET_URLS_INTERNAS);
      commit("setUrlsInternas", response);
    }
  }
};